import { Button, Drawer, DrawerSize, Icon, Popover, Position } from "@blueprintjs/core"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import MeatSelectorList from "../MeatSelectorList"
import { MouseEvent, useEffect, useRef, useState } from "react"
import { HISTORY_TYPE, IHistoryStep, ILandingSection } from "src/modules/pe-landing-module/data/interfaces"
import createMeat from "../utils/createMeat"
import { __ } from "src/libs/utilities"
import { components } from "src/modules/pe-landing-module/data/utils/components"
import updateSection from "../utils/updateSection"

/* Protopia Ecosystem component */
export interface IAddMeatDrawerProps {
   
}
const AddMeatDrawer = (props: IAddMeatDrawerProps): JSX.Element => {
    const currentLanding            = useLandingStore( (state:ILandingStore) => state.currentLanding )
    const isAddMeatDrawerOpen       = useLandingStore( (state:ILandingStore) => state.isAddMeatDrawerOpen )
    const addMeatDrawerSectionId    = useLandingStore( (state:ILandingStore) => state.addMeatDrawerSectionId )
    const addMeatDrawerMeatId       = useLandingStore( (state:ILandingStore) => state.addMeatDrawerMeatId )
    const [size, setSize]           = useState<DrawerSize | number>( 360 )

    const ref = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const div = ref.current
        if(!!div) {
            (div as HTMLDivElement).style.top = "200px"; 
            (div as HTMLDivElement).style.left = "50px" 
        }
        return () => {
            setSize(360)
        }
    }, [])

    useEffect(() => { 
        setSize( 360 ) 
    }, [isAddMeatDrawerOpen])

    const onClose = () => {
        useLandingStore.setState({ isAddMeatDrawerOpen: false })
    }
    const onOpen = () => {
        setSize( 800 )
    }
    const onNewSection = (evt: MouseEvent, key: string, n: number, ) => {
        const historyStep: IHistoryStep = {
            data: null,
            prevData: null,
            type: HISTORY_TYPE.SECTION,
            title : __("Add new Meat ") + __(components()[key].title),
        } 
        const section:ILandingSection = currentLanding.sections.find((section: ILandingSection) => section.id === addMeatDrawerSectionId) 
        const newSection: ILandingSection = { ...section, }
        const index = section.data.findIndex(( d, ii ) => d.id === addMeatDrawerMeatId )  
        historyStep.prevData = JSON.parse( JSON.stringify( section ) )
        const newData = createMeat(key, n, {})
        newSection.data.splice( index + 1, 0, newData )
        historyStep.data = newSection 
        updateSection(newSection, historyStep)
        
        console.log( index, addMeatDrawerMeatId, newSection )
        
        useLandingStore.setState({ isAddMeatDrawerOpen: false })
    }

    // return <Popover
    //         position={ Position.LEFT }
    //         portalClassName="z-index-110-none"
    //         isOpen={ !!isAddMeatDrawerOpen } 
    //         onClose={ onClose }
    //         content={<MeatSelectorList onClick={ onNewSection } />}
    //     >
    //         <div ref={ref} />
    //     </Popover>

    return <Drawer
        position={ Position.LEFT }
        portalClassName="z-index-110-none"
        isOpen={ !!isAddMeatDrawerOpen } 
        size={ size }
        hasBackdrop={ false }
        onClose={ onClose }
    >
        <div style={{ backgroundColor: "var(--drop-select-color)", height: "100dvh" }}>
            <MeatSelectorList 
                onClick={ onNewSection } 
                onOpen={ onOpen }
                className="full-height"
                textClassName="pl-2 text-normal"
            />
        </div>
    </Drawer>
            
             
}
export default AddMeatDrawer